import { TextField } from "@mui/material";
import FieldErrorTooltip from "../FieldErrorTooltip";
const ReduxTextField = ({ label, input, meta: { invalid, error, submitFailed }, ...custom }: any) => {
    const showError = invalid && submitFailed;
    return (<div>
        <TextField label={label} placeholder={label} variant={custom.variant || 'standard'} error={showError} {...custom}
        helperText={!showError ? custom.helperText : undefined} {...input}/>
        <FieldErrorTooltip error={error} visible={showError} />
    </div>);
};
export default ReduxTextField;
